import { fetch } from '@maxtropy/components';

// ========== 能源成本接口类型定义 ==========

// 时间分辨率类型
export enum TimeResolution {
  DAY = 'DAY',
  MONTH = 'MONTH',
}

// 能源成本请求参数
export interface EnergyCostRequest {
  fromTime: number;
  toTime: number;
  timeResolution: TimeResolution;
}

// 峰谷平时段数据
export interface TimePeriodData {
  value?: number;
  ratio?: number;
}

// 用电数据
export interface ElectricityData {
  cost?: number;
  value?: number;
  ratio?: number;
  // 尖峰
  summit?: TimePeriodData;
  // 峰
  peak?: TimePeriodData;
  // 平
  plain?: TimePeriodData;
  // 谷
  valley?: TimePeriodData;
}

// 能源介质明细数据
export interface EnergyMediumDetail {
  energyMediumId?: number;
  energyMediumName?: string;
  plan?: number;
  actual?: number;
  ratio?: number;
}

// 用水数据
export interface WaterData {
  cost?: number;
  // 占比
  ratio?: number;
  // 中水
  middleWater?: EnergyMediumDetail;
  // 新鲜水
  freshWater?: EnergyMediumDetail;
}

// 用气数据
export interface GasData {
  cost?: number;
  // 占比
  ratio?: number;
  // 用气能源介质数据列表
  gasEnergyMediumData?: EnergyMediumDetail[];
}

// 能源成本响应数据
export interface EnergyCostResponse {
  // 实际成本
  actual?: number;
  // 计划成本
  plan?: number;
  // 占比
  ratio?: number;
  // 用电数据
  electricityData?: ElectricityData;
  // 用水数据
  waterData?: WaterData;
  // 用气数据
  gasData?: GasData;
}

// ========== 能源用量接口类型定义 ==========

// 用电量数据
export interface ElectricityUsageData {
  value?: number;
  greenRatio?: number;
  usageData?: EnergyMediumDetail;
  // 尖峰
  summit?: TimePeriodData;
  // 峰
  peak?: TimePeriodData;
  // 平
  plain?: TimePeriodData;
  // 谷
  valley?: TimePeriodData;
}

// 用水量数据
export interface WaterUsageData {
  // 中水
  middleWater?: EnergyMediumDetail;
  // 新鲜水
  freshWater?: EnergyMediumDetail;
}

// 能源用量响应数据
export interface EnergyUsageResponse {
  // 实际用量
  actual?: number;
  // 计划用量
  plan?: number;
  // 占比
  ratio?: number;
  // 用电数据
  electricityData?: ElectricityUsageData;
  // 用水数据
  waterData?: WaterUsageData;
  // 用气数据列表
  gasData?: EnergyMediumDetail[];
}

// 获取能源用量数据
export function getEnergyUsage(params: EnergyCostRequest): Promise<EnergyUsageResponse> {
  return fetch(
    // `http://10.50.16.221:40001/mock/487/api/v2/h5/energy/overview/usage`,
    `/api/v2/h5/energy/overview/usage`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

// ========== API 函数 ==========

// 获取能源成本数据
export function getEnergyCost(params: EnergyCostRequest): Promise<EnergyCostResponse> {
  return fetch(
    // `http://10.50.16.221:40001/mock/487/api/v2/h5/energy/overview/cost`,
    `/api/v2/h5/energy/overview/cost`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

// 节能降耗分析
export interface EnergyAnalysisResponse {
  // 节能降碳
  energySaving?: string;
  // 本年光伏发电量
  pvPower?: number;
  // 本年光伏发电量占比
  pvPowerRate?: number;
  // 节约电费
  saveElectricity?: number;
  // 二氧化碳减排
  carbonReduction?: number;
  // 节约标准煤
  saveStandardCoal?: number;
  // 植树数量
  treeNum?: number;
}

// 获取节能降耗分析
export function getEnergyAnalysis(): Promise<EnergyAnalysisResponse> {
  return fetch(
    // `http://10.50.16.221:40001/mock/487/api/v2/h5/energy/overview/analysis`,
    `/api/v2/h5/energy/overview/analysis`,
    {
      method: 'POST',
    },
    true
  );
}
